var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Yinshiyun"},[_c('iframe',{ref:"video_player",attrs:{"src":_vm.baseUrl+'yingshi-iframe.html'}})])}
var staticRenderFns = []

export { render, staticRenderFns }